import { Button, Flex, Link, Text } from 'rebass';
import React from 'react';
import styled, { keyframes } from 'styled-components';
import theme from '../../../styles/theme';
import { TEXT_ANIMATION_DURATION } from './constants';
import { isMobile } from 'react-device-detect';

const StyledLink = styled(Link)`
  color: #000;
`;
const slideLeft = keyframes`
  0% {
    opacity: 0;
    transform: translateY(15px);
  };
  100% {
    opacity: 1;
    transform: translateY(0px);
  };
`;

const Description = styled(Text)`
  opacity: 0;
  animation: 400ms cubic-bezier(0.64, 0, 0.28, 1) 0s 1 normal forwards running ${slideLeft};
`;

const FootNote = styled(Flex)`
  opacity: 0;
  animation-delay: 1.24s;
  animation-direction: normal;
  animation-duration: 0.4s;
  animation-fill-mode: forwards;
  animation-iteration-count: 1;
  animation-name: ${slideLeft};
  animation-play-state: running;
  animation-timing-function: cubic-bezier(0.64, 0, 0.28, 1);
  box-sizing: border-box;
  flex: 1;
  flex-direction: column;
  justify-content: flex-end;
`;

export const ExplorePlans = ({ onContinue }) => {
  const title = 'Explore weight loss plans.';
  const description = 'Learn about treatment options based on your goals, habits, and health history.';

  return (
    <Flex flexDirection={'column'} flex={1} mt={4}>
      <Flex flexWrap={'wrap'}>
        {title.split(' ').map((x, i) => {
          return (
            <Text key={`title_${x}_i`} style={{ fontSize: isMobile ? '36px' : '43px', color: theme.color.pink, fontWeight: 400 }}>
              {x}
              &nbsp;
            </Text>
          );
        })}
      </Flex>

      <Flex flexWrap={'wrap'} mt={4} >
        {description.split(' ').map((x, i) => {
          return (
            <Description key={`description_${x}_i`} style={{ fontSize: isMobile ? '24px' : '32px', fontWeight: 500, animationDelay: `${i * TEXT_ANIMATION_DURATION}s` }}>
              {x}
              &nbsp;
            </Description>
          );
        })}
      </Flex>

      <FootNote mb={4}>
        <Text style={{ color: 'rgba(0, 0, 0, 0.33)', fontSize: '12px' }} mb={2}>
          By clicking 'Continue', you agree that Paloma Health may use your responses to personalize your experience and other purposes as described in our&nbsp;
          <StyledLink href="https://palomahealth.com/legal-doc/privacy-policy" target="_blank">
            Privacy Policy
          </StyledLink>
          . Responses prior to account creation will not be used as part of your medical assessment.
        </Text>
        <Button variant={'primary'} onClick={onContinue}>
          Continue
        </Button>
      </FootNote>
    </Flex>
  );
};
